import { Button, Col, Row } from 'antd';
import { useEffect, useState } from 'react';

import styles from './billing-addresses.module.scss';
import { Address } from 'modules/profile/models/Address';
import ProfileBillingAddressItemComponent from '../billing-address-item/billing-address-item';

function ProfileBillingAddressesComponent() {
	const addresses: Address[] = [
		{
			location: 'Ap #285-7193 Ullamcorper Avenue Amesbury',
			state: 'HI 93373',
			country: 'US',
			isPrimary: true,
		},
		{
			location: 'Ap #285-7193 Ullamcorper Avenue Amesbury',
			state: 'HI 93373',
			country: 'US',
			isPrimary: true,
		},
		{
			location: 'Ap #285-7193 Ullamcorper Avenue Amesbury',
			state: 'HI 93373',
			country: 'US',
			isPrimary: true,
		},
	];

	return (
		<>
			<div className="sectionContainer titled">
				<header>Email Preferences</header>
				<main>
					<Row gutter={[20, 20]}>
						{addresses.map((address, i) => (
							<Col span={24} md={12} key={i}>
								<ProfileBillingAddressItemComponent address={address} no={i + 1} />
							</Col>
						))}

						<Col span={24} md={12}>
							<div className={styles.addAddressDiv}>
								<div>
									<h6>This is a very important note!</h6>
									<p className="mb-0">Writing headlines for blog posts is much science and probably</p>
								</div>
								<Button type="primary">Add address</Button>
							</div>
						</Col>
					</Row>

					<Row>
						<Col>
							<div className={styles.taxDiv}>
								<h6>Tax Location</h6>
								<p>Saudi Arabia - 10% VAT</p>
								<a href="#">More info</a>
							</div>
						</Col>
					</Row>
				</main>
			</div>
		</>
	);
}

export default ProfileBillingAddressesComponent;
